export function accordion() {
    const $accordion = $(".accordion-holder");
    const $accordionItem = $accordion.find(".accordion-item");
    const $accordionItemNav = $accordion.find(".accordion-nav-item");

    $accordionItem.find("button").on("click", function () {
        let $this = $(this);
        let index = $this.parents(".accordion-item").index();
        let $parent = $this.parents(".accordion-holder");
        let $buttonParent = $this.parents(".accordion-item");
        let $navButtonParent = $parent.find(".accordion-nav-item");
        if (!$buttonParent.hasClass("active")) {
            $parent.find(".accordion-item").removeClass("active");
            $buttonParent.addClass("active");
            $navButtonParent.removeClass("active");
            $navButtonParent.eq(index).addClass("active");
        }
    });
    $accordionItemNav.find("button").on("click", function () {
        let $this = $(this);
        let index = $this.parents(".accordion-nav-item").index();
        let $parent = $this.parents(".accordion-holder");
        let $buttonParent = $parent.find(".accordion-item");
        let $navButtonParent = $parent.find(".accordion-nav-item");
        if (!$this.parent(".accordion-nav-item").hasClass("active")) {
            $buttonParent.removeClass("active");
            $navButtonParent.removeClass("active");
            $this.parent(".accordion-nav-item").addClass("active");
            $buttonParent.eq(index).addClass("active");
        }
    });
    $accordion.each(function () {
        $(this).find(".accordion-item:first button").trigger("click");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js